import api from './api';
import { downloadAnexoPost } from './apiAnexo';

export const findAll = (filtros: any) => {
    return api.post<any[]>(`/relatorios/relatorioSubContratacao`, filtros, { disableNotification: 'true', });
}

export const exportToExcel = async (filtros: any) => {
    const url = '/api/relatorios/relatorioSubContratacao/exportToExcel';
    await downloadAnexoPost('Relatório de Subcontratações.xlsx', url, filtros);
  }